module.exports = __webpack_public_path__ + "static/media/33b Stand Up.1ba0157f.jpg";